import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import TableSortLabel from '@mui/material/TableSortLabel';

const smallScreen = document.body.clientWidth < 1400;

const styles = theme => ({
    cell: {
        padding: smallScreen ? '4px 6px 4px 6px' : '4px 8px 4px 8px',
        whiteSpace: ''
    },
    stickyHeader: {
        position: 'sticky',
        backgroundColor: theme.palette.background.paper
    }
});

class EnhancedTableHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { classes, columnData, onSelectAllClick, order, orderBy, numSelected, rowCount, showSelectColumn, stickyHeader } = this.props;
        
        let style = {};
        if (stickyHeader)
            style.top = stickyHeader;

        return (
            <TableHead>
                <TableRow className={stickyHeader && classes.stickyHeader} style={style}>
                    {
                        showSelectColumn ? (
                            <TableCell className={classes.cell} >
                                <Checkbox
                                    indeterminate={numSelected > 0 && numSelected < rowCount}
                                    checked={numSelected === rowCount}
                                    onChange={onSelectAllClick}
                                />
                            </TableCell>
                        ) : null
                    }
                    {columnData.map((column) => {
                        return (
                            <TableCell
                                className={classes.cell}
                                key={column.id}
                                align={column.numeric ? 'right' : 'left'}
                                sortDirection={orderBy === column.id ? order : false}
                            >
                                {column.tri ? (
                                    <Tooltip
                                        title="Trier"
                                        placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                        enterDelay={300}
                                    >
                                        <TableSortLabel
                                            active={orderBy === column.id}
                                            direction={order}
                                            onClick={this.createSortHandler(column.id)}
                                        >
                                            {column.label}
                                        </TableSortLabel>
                                    </Tooltip>
                                ) : (column.label)}
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,

    showSelectColumn: PropTypes.bool.isRequired,
    onSelectAllClick: PropTypes.func,
    numSelected: PropTypes.number,

    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    columnData: PropTypes.array.isRequired,

    stickyHeader: PropTypes.number
};


export default withStyles(styles)(EnhancedTableHead);